<div class="enquiries_sec">
    <section class="table_section">
        <div class="custom-sticky-table" fxLayout="column" fxLayoutAlign="start stretch">
            <button type="button" mat-button class="table_fixed_add" (click)="addJobRole()">
                <i class="material-icons">add_circle_outline</i> Add Role
            </button>
            <perfect-scrollbar>
                <table mat-table [dataSource]="role" matSort class="mat-elevation-z8">

                    <ng-container matColumnDef="sNo">
                        <th mat-header-cell *matHeaderCellDef> S.No </th>
                        <td mat-cell *matCellDef="let element; let i = index"> {{ i + 1 }} </td>
                    </ng-container>

                    <ng-container matColumnDef="role_name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Role Name </th>
                        <td mat-cell *matCellDef="let element"> {{ element.role_name }} </td>
                    </ng-container>

                    <ng-container matColumnDef="created_at">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Created At </th>
                        <td mat-cell *matCellDef="let element"> {{ element.created_at | date: 'dd-MM-yyyy hh:mm:ss' }} </td>
                    </ng-container>

                    <ng-container matColumnDef="updated_at">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Updated At </th>
                        <td mat-cell *matCellDef="let element"> {{ element.updated_at | date: 'dd-MM-yyyy hh:mm:ss' }} </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="element.role_name !== 'Role'">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button type="button" mat-menu-item [routerLink]="" (click)="editRoles(element)">
                                    <mat-icon>edit</mat-icon> Edit
                                </button>
                                <button type="button" mat-menu-item [routerLink]="" (click)="deleteRoles(element)">
                                    <mat-icon>delete</mat-icon> Delete
                                </button>

                            </mat-menu>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                </table>

            </perfect-scrollbar>
        </div>
    </section>
</div>